/**
 * Tarjeta de speaker: imagen circular con borde lime verde, nombre debajo.
 * Clic en la imagen abre el modal con los datos completos.
 * variant="list": layout vertical (foto arriba, nombre abajo) sin fondo, 5% espacio arriba de la foto.
 */
function SpeakerCard({ speaker, onClick, variant = 'card' }) {
  const name = speaker?.nombre || speaker?.name || '';
  const displayName = name.startsWith('Dr.') || name.startsWith('Dra.') ? name : `Dr. ${name}`;
  const imageUrl = speaker?.profile?.startsWith('http') ? speaker.profile : null;

  if (variant === 'list') {
    return (
      <button
        type="button"
        onClick={onClick}
        className="w-full flex flex-col items-center cursor-pointer group hover:opacity-90 transition-opacity focus:outline-none focus:ring-2 focus:ring-[#CFFF33] focus:ring-offset-2 focus:ring-offset-transparent rounded-lg"
        aria-label={`Ver datos de ${displayName}`}
      >
        <div className="mt-[5%] w-28 h-28 sm:w-32 sm:h-32 flex-shrink-0 rounded-full border-2 border-[#CFFF33] overflow-hidden bg-gray-200/50 flex items-center justify-center">
          {imageUrl ? (
            <img src={imageUrl} alt={displayName} className="w-full h-full object-cover object-top" />
          ) : (
            <span className="text-2xl text-gray-400">👤</span>
          )}
        </div>
        <p className="text-[#CFFF33] font-bold text-base sm:text-lg mt-2">{displayName}</p>
      </button>
    );
  }

  return (
    <div className="flex flex-col items-center gap-4 cursor-pointer group">
      <button
        type="button"
        onClick={onClick}
        className="focus:outline-none focus:ring-2 focus:ring-[#CFFF33] focus:ring-offset-2 rounded-full p-1.5 transition-transform group-hover:scale-105"
        aria-label={`Ver datos de ${displayName}`}
      >
        <div className="w-32 h-32 sm:w-40 sm:h-40 rounded-full border-4 border-[#CFFF33] overflow-hidden bg-gray-200 flex items-center justify-center">
          {imageUrl ? (
            <img
              src={imageUrl}
              alt={displayName}
              className="w-full h-full object-cover object-top"
            />
          ) : (
            <span className="text-4xl text-gray-400">👤</span>
          )}
        </div>
      </button>
      <p className="text-[#CFFF33] font-bold text-lg text-center">
        {displayName}
      </p>
    </div>
  );
}

export default SpeakerCard;
